import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StockageService {
  public clear(): void {
    if (typeof window !== 'undefined') {
      localStorage.clear();
    }
  }

  public getItem(key: string): string | null {
    if (typeof window === 'undefined') {
      return null;
    }
    return localStorage.getItem(key);
  }

  public setItem(key: string, value: string): void {
    if (typeof window !== 'undefined') {
      localStorage.setItem(key, value);
    }
  }
}
